import { HttpClient } from '@shift/contracts';
import { runtimeEnv } from '../config/runtime-env.js';

/**
 * The one HTTP client for the app. Components never call `fetch`; they go
 * through a Pinia store or a TanStack Query hook that uses this.
 *
 * The access token is read lazily from the session store rather than captured,
 * so a refresh mid-session is picked up without rebuilding the client. The
 * `onUnauthorized` hook is registered by the session store to avoid a circular
 * import between the client and the store that owns the token.
 */
let readAccessToken: () => string | undefined = () => undefined;
/** Returns true once a new access token is in place; the client then retries. */
let handleUnauthorized: () => boolean | Promise<boolean> = () => false;

export const registerSessionHooks = (hooks: {
  getAccessToken: () => string | undefined;
  onUnauthorized: () => boolean | Promise<boolean>;
}): void => {
  readAccessToken = hooks.getAccessToken;
  handleUnauthorized = hooks.onUnauthorized;
};

export const apiClient = new HttpClient({
  baseUrl: runtimeEnv.apiBaseUrl,
  getAccessToken: () => readAccessToken(),
  onUnauthorized: () => handleUnauthorized(),
  generateRequestId: () => crypto.randomUUID(),
});
